import useSWR, { KeyedMutator } from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { tsIoValidate } from "../../../../utils/general/generalUtils"
import { getClientProtected } from "../../clients/clients"
import { NO_REVALIDATE_CONFIG } from "../../swrConfig"
import {
    IInviteDetails,
    IPendingInvite,
    PendingInvite,
} from "../../types/account/pendingInvite"
import { PENDING_INVITE } from "../../urls/private"

interface IUseCheckInvites {
    isChecking: boolean
    hasInvite: undefined | boolean
    invite: IInviteDetails | undefined
    error: undefined | AppError
    mutate: KeyedMutator<IPendingInvite>
}

/**
 * Checks if a given user has any pending invites
 * @returns {IUseCheckInvites} - loading and error states.
 */
const useCheckInvites = (): IUseCheckInvites => {
    const { data, error, isLoading, mutate } = useSWR(
        PENDING_INVITE,
        async (url: string): Promise<IPendingInvite> => {
            try {
                const res = await getClientProtected(url)
                return tsIoValidate<IPendingInvite>(
                    PendingInvite,
                    res,
                    "Invalid invite format received"
                )
            } catch (err) {
                throw parseAndThrowAppError(err)
            }
        },
        NO_REVALIDATE_CONFIG
    )

    return {
        isChecking: isLoading,
        hasInvite: data?.invite_exists,
        invite: data?.detail || undefined,
        error,
        mutate,
    }
}

export default useCheckInvites
